import React, { useEffect, useRef } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { performCentralLogout } from '../utils/centralLogout'
import { getMainBackgroundClass, getTextClass } from '../utils/themeUtils'
import { useSettings } from '../hooks/useSettings'

// Atterraggio del logout proveniente dalle VM: pulisce la sessione del
// portale PRIMA di mostrare /login, così la PublicRoute non rimanda alla
// dashboard (che auto-redirige alla VM col token ancora nel cookie).
const LogoutPage = () => {
  const { t } = useTranslation('auth')
  const { currentTheme } = useSettings()
  const started = useRef(false)

  useEffect(() => {
    // StrictMode monta due volte: il logout è idempotente ma evitiamo la
    // doppia chiamata di revoca.
    if (started.current) return
    started.current = true
    performCentralLogout().finally(() => {
      window.location.replace('/login')
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      className={clsx(
        'flex items-center justify-center min-h-screen',
        getMainBackgroundClass(currentTheme),
        getTextClass(currentTheme)
      )}
    >
      <div className="text-center" data-testid="portal-logging-out">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-current mx-auto mb-4"></div>
        <p className="text-lg">{t('portal.loggingOut')}</p>
      </div>
    </div>
  )
}

export default LogoutPage
